/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import styled from 'styled-components';
import { TourItemType } from '@bb/domain/dist/types';

import { useBreakpoint } from 'hooks';
import { Icon, Text, theme } from 'components';
import { TourItemContent } from '../types';

// TODO: Might be used after the MVP
// const DEFAULT_THUMBNAIL: Record<TourItemType, JSX.Element> = {
//   APPOINTMENT: <Icon type="antdHomeFilled" width={20} />,
//   ROUTE_STOP: <Icon type="marker" width={20} />,
// };

interface InfoWindowsProps {
  inputRef: React.MutableRefObject<HTMLDivElement[]>;
  item: TourItemContent;
  index: number;
  forSizeOnly?: boolean;
}

const InfoWindows: React.FC<InfoWindowsProps> = ({
  inputRef,
  item,
  index,
  forSizeOnly,
}) => {
  const { md } = useBreakpoint();

  return (
    <StyledNoDisplays
      key={`infocontainer-${index}-${forSizeOnly ? 'size' : 'default'}`}
      ref={ref => {
        // eslint-disable-next-line no-param-reassign
        inputRef.current[index] = ref;
      }}
      $forSizeOnly={forSizeOnly}
    >
      <StyledInfoContainer>
        {/* TODO: Might be used after the MVP
      <StyledImageContainer>
        {item.thumbnail ? (
          <StyledImage src={item.thumbnail} />
        ) : (
          <StyledIconContainer>
            {DEFAULT_THUMBNAIL[item.type]}
          </StyledIconContainer>
        )}
      </StyledImageContainer> */}
        {md && <StyledText>{item.locationName}</StyledText>}
      </StyledInfoContainer>
    </StyledNoDisplays>
  );
};

export default InfoWindows;

const StyledNoDisplays = styled.div<{ $forSizeOnly?: boolean }>`
  ${({ $forSizeOnly }) =>
    $forSizeOnly &&
    `
    position: absolute;
    bottom: 0;
    visibility: hidden;
  `}
`;

const StyledInfoContainer = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
`;

// TODO: Might be used after the MVP
// const StyledImageContainer = styled.div`
//   margin-right: 10px;
// `;

// const StyledImage = styled.img`
//   width: 36px;
//   height: 36px;
//   border-radius: 4px;
// `;

// const StyledIconContainer = styled.div`
//   width: 36px;
//   height: 36px;
//   border-radius: 4px;
//   background-color: ${theme.gray4};
//   padding: 8px;
// `;

// This is another fragile way to override G MAP internal css
const StyledText = styled(Text)`
  font:
    600 16px inter,
    'Helvetica Neue',
    Arial,
    sans-serif !important;
  text-shadow:
    -2px 0 white,
    0 2px white,
    2px 0 white,
    0 -2px white;
  line-height: 24px;
`;
